import { StudentClessonProblemResult } from '@yandex-int/k-common';
import {
    getClessonsResults,
    GetClessonsResultsResponseData,
} from '@yandex-int/k-common/client/api/defs/get-clessons-results';
import {
    getCriteriaMarksBatch,
    GetCriteriaMarksResponse,
} from '@yandex-int/k-common/client/api/defs/get-criteria-marks';
import { showNetworkError } from 'platform-components';
import { call, put, all, takeEvery } from 'redux-saga/effects';

import { getOpenAnswerAttemptId } from 'store/clesson-results/utils';

import { clessonResultsActions } from './actions';

export function* clessonResultsSagasWatcher() {
    yield all([takeEvery(clessonResultsActions.getClessonsResultsRequest, getClessonsResultsSaga)]);
}

function* getClessonsResultsSaga(action: ReturnType<typeof clessonResultsActions.getClessonsResultsRequest>) {
    const { clessonIds } = action.payload;
    const clessonIdsChunks: number[][] = [];
    const chunkSize = 100;

    for (let i = 0; i < clessonIds.length; i += chunkSize) {
        clessonIdsChunks.push(clessonIds.slice(i, i + chunkSize));
    }

    try {
        const clessonResultsChunks: GetClessonsResultsResponseData[] = yield all(
            clessonIdsChunks.map((chunks) => call(getClessonsResults, { clessonIds: chunks }))
        );

        const clessonResults: GetClessonsResultsResponseData = clessonResultsChunks.reduce((result, chunk) => {
            return result.concat(chunk);
        }, []);

        const problemResults = clessonResults.map(({ students }) => students.map(({ problems }) => problems)).flat(2);
        const criteriaMarks = (yield call(getProblemCriteriaMarks, problemResults)) as unknown as any;

        yield put(
            clessonResultsActions.getClessonsResultsSuccess({
                clessonResults,
                criteriaMarks,
            })
        );
    } catch (error) {
        yield put(clessonResultsActions.getClessonsResultsError({ clessonIds }));
        yield put(showNetworkError(error));
        console.error(error);
    }
}

function* getProblemCriteriaMarks(problemResults: StudentClessonProblemResult[]) {
    try {
        const problemAttemptIds = problemResults
            .map((problemResult) => getOpenAnswerAttemptId(problemResult))
            .filter(Boolean) as string[];

        if (!problemAttemptIds.length) {
            return {};
        }

        const response: GetCriteriaMarksResponse = yield call(getCriteriaMarksBatch, problemAttemptIds);
        return response.result;
    } catch (error) {
        console.error(error);
        return {};
    }
}
